<ng-container *transloco="let t">
  <div class="flex h-full flex-col">
    <div class="flex items-center justify-between border-b border-gray-200 px-5 py-2">
      <div class="flex items-center gap-2">
        @if (isSidebarCollapsed()) {
          <IButton
            icon="icon-[hugeicons--sidebar-right-01]"
            [tooltipValue]="t('page-title.expand_sidebar')"
            [size]="'sm'"
            color="gray"
            variant="ghost"
            (onClick)="isSidebarCollapsed.set(!isSidebarCollapsed())"
          />
        }
        <div class="flex items-center">
          @if (subPage()) {
            <IButton
              [label]="parentTitle()"
              color="gray"
              variant="ghost"
              class="[&_span]:!text-slate-500"
              [to]="parentRouteUrl()"
              queryParamsHandling="merge"
              testid="previous-page"
            />
            <span class="text-gray-300">/</span>
          } @else {
            <div class="px-3 py-1.5 text-sm font-semibold tracking-tight text-gray-700">{{ parentTitle() }}</div>
          }
          <div #breadcrumbPortalOutlet></div>
          <div>
            @if (title(); as title) {
              <app-breadcrumb-item [title]="t(title)" />
            }
          </div>
        </div>
        <div class="ml-5 flex items-center">
          @if (withMultiAccountSelector()) {
            <app-multi-account-selector></app-multi-account-selector>
          } @else if (withAccountSelector()) {
            <app-account-selector />
          }

          <div class="flex gap-2 pr-2">
            @if (invalidAccountMarketplaces().length > 0) {
              <IButton
                [label]="t('default-layout.grant_access')"
                icon="icon-[lucide--file-lock-2]"
                color="orange"
                (onClick)="requestGrant()"
              />
            }

            @if (pendingValidationAccountMarketplaces().length > 0) {
              <IButton
                color="orange"
                icon="icon-[lucide--book-open-check]"
                [label]="t('default-layout.validate_catalog')"
                [tooltipValue]="t('default-layout.validate_seeling_partner_api')"
                (onClick)="validateAccountIntegration()"
              />
            }
          </div>
        </div>
      </div>

      <div class="flex items-center gap-2">
        @if (withCurrencySelector()) {
          <app-currency-selection />
        }
        @if (withDatePicker()) {
          <app-date-range-selector />
        }
      </div>
    </div>

    <div class="relative flex-1 p-5" [class.pb-24]="withChatbotSafeMargin()">
      @if (loading()) {
        <div class="absolute inset-0 flex h-full w-full items-center justify-center">
          <div class="flex items-center gap-2">
            <span class="icon-[lucide--loader-circle] animate-spin text-lg text-gray-400"></span>
            <div class="font-semibold text-gray-400">Loading</div>
          </div>
        </div>
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </div>
</ng-container>
